import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { List, Empty, message, Skeleton, Form, Grid } from 'antd';
import { UPLOADS } from '../../params';
import { 
    getPostsList
} from '../../API/posts';
import { BsArrowRight } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
SwiperCore.use([Autoplay, Navigation, Pagination]);

const { useBreakpoint } = Grid;

export const Memos = props => {
    const dispatch = useDispatch();

    const screens = useBreakpoint();
    const app_global = useSelector(state => state.app_global);
    const profile = useSelector(state => state.profile);
    const posts = useSelector(state => state.posts);

    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [posts_list_search, setPosts_list_search] = useState("");

    const [form_posts_list_search] = Form.useForm();

    form_posts_list_search.setFieldsValue({ 
        search: posts_list_search
    });

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {        
        await getPostsList({
            category: 4
        },dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getPostsList]`, `color: #A366FF`, json );
            if (json?.code) {
                //Done
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    function posts_list_search_change (e) { 
        setPosts_list_search(e.target.value.replace(/\s+/g,' '));
    }

    var obj = {
        get posts_list () {
            if ( posts.posts_list.length > 0 ) {
                let search = posts_list_search.toLowerCase();
                return posts.posts_list.filter( function( item ) {
                    return(
                        item['title'].toLowerCase().indexOf( search ) > -1
                    );
                } );
            } else {
                return posts.posts_list;
            }
        },
    };
    
    return (
        <section className='container_full --memos'>
            <section className='top'>
                <section className='container shadow default_padding'>
                    <h1>Памятки для пациентов</h1>
                </section>
            </section>
            <section className='body'>
                <section className='container shadow default_padding'>
                    <div className='content'>
                        {app_global.loading ?
                            <Skeleton active />
                        :
                            posts.loading ?
                                <Skeleton active />
                            :
                                <>
                                    <List itemLayout="vertical"
                                        className='posts_list'
                                        size="large"
                                        pagination={false}
                                        locale={{
                                            emptyText: 
                                                <Empty 
                                                    description="Список статей пуст"
                                                />
                                        }}
                                        dataSource={obj.posts_list}
                                        renderItem={(item, index) => (
                                            <List.Item key={index} >
                                                <Link className='posts_item' to={`/memos/${item.id}`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                    {item.photo_mini === null ?
                                                        null
                                                    :
                                                        <div className='posts_item_top'>
                                                            <img src={`${UPLOADS}/${item.photo_mini}`} />
                                                        </div>
                                                    }
                                                    <div className={`posts_item_bottom ${item.photo_mini === null ? 'only_content' : ''}`}>
                                                        <h2>{item.seo_title}</h2>
                                                        <p className='excerpt' dangerouslySetInnerHTML={{ __html: item.excerpt.replace('\n',"<br />") }}></p>
                                                    </div>
                                                </Link>
                                            </List.Item>
                                        )}
                                    />
                                    <div className='slider_mob'>
                                        <Swiper
                                            loop
                                            spaceBetween={12}
                                            slidesPerView={2}
                                            pagination={{
                                                type: "progressbar",
                                            }}
                                            navigation={{
                                                prevEl: navigationPrevRef.current,
                                                nextEl: navigationNextRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                            }}
                                            breakpoints={{
                                                1100: {
                                                    slidesPerView: 5,
                                                },
                                                1050: {
                                                    slidesPerView: 4.5,
                                                },
                                                950: {
                                                    slidesPerView: 4.2,
                                                },
                                                850: {
                                                    slidesPerView: 4,
                                                },
                                                750: {
                                                    slidesPerView: 3.5,
                                                },
                                                700: {
                                                    slidesPerView: 3.2,
                                                },
                                                630: {
                                                    slidesPerView: 3,
                                                },
                                                576: {
                                                    slidesPerView: 2.5,
                                                },
                                                575: {
                                                    slidesPerView: 2,
                                                },
                                            }}
                                        >
                                            {
                                                obj.posts_list.map((item) => 
                                                    <SwiperSlide>
                                                        <Link className='posts_item' to={`/memos/${item.id}`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                            {item.photo_mini === null ?
                                                                null
                                                            :
                                                                <div className='posts_item_top'>
                                                                    <img src={`${UPLOADS}/${item.photo_mini}`} />
                                                                </div>
                                                            }
                                                            <div className={`posts_item_bottom ${item.photo_mini === null ? 'only_content' : ''}`}>
                                                                <h2>{item.seo_title}</h2>
                                                                <p className='excerpt' dangerouslySetInnerHTML={{ __html: item.excerpt.replace('\n',"<br />") }}></p>
                                                            </div>
                                                        </Link>
                                                    </SwiperSlide>
                                                )
                                            }
                                        </Swiper>
                                    </div>
                                </>
                        }
                    </div>
                </section>
            </section>
        </section>
    );
};